<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 16 14">
    <path d="M5 7v4h-2v-4h2zM8 3v8h-2v-8h2zM16 12v1h-16v-12h1v11h15zM11 5v6h-2v-6h2zM14 2v9h-2v-9h2z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-bar-chart.html